import { NavigationItem } from '@type-declarations/navigationItem';

export default function isValidLink<T extends NavigationItem>(
  item: T,
): boolean {
  const isValid = !!(item.internalLink?.page?.[0] || item.externalLink);

  if (!isValid) {
    console.warn(`Item with title "${item.title}" has no valid link`);
  }

  return isValid;
}
